export const line=function(echarts,id,dataarr,data,name){
    var theSeven = echarts.init(document.getElementById(id));
    var option = {
        legend: {
            // data: [ '挂牌均价','挂牌量'],
            bottom: 1,
            selectedMode: false,
            show:false,
            textStyle: {
                color: '#acaeaf'
            },
            
        },
        color:['#3569fd'],
        tooltip: {
            trigger: 'axis',
            show: true,
            axisPointer: {
                type: 'none'
            },
            formatter:'{b}(月)<br>挂牌均价{c1}(千元)<br>挂牌量：{c}(套)'
        },
        xAxis:
            {
                type: 'category',
                data: dataarr,
                // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                axisLine: {
                    show: true,
                    lineStyle:{
                        color:'#f5f6f7'
                    }
                    
                },
                axisLabel: {
                    textStyle: {
                        color: '#acaeaf'
                    }
                },
                axisTick: {
                    show: false,
                    length: 3,
                    lineStyle: {
                        color: '#acaeaf'
                    }
                },
                offset: 10,
                nameTextStyle: {
                    fontSize: 15
                },
                splitNumber: 2,
                scale: true,
                show: true,
                splitLine: {
                    show: false
                }
            },
        yAxis: 
            {
                name: name,
                nameLocation: 'end',
                nameGap: '12',
                nameRotate: 0,
                nameTextStyle: {
                    color: '#acaeaf',
                    fontSize: 12
                },
            type: 'value',
            scale: false,
            position: 'left',
            show: true,
            axisLabel: {
                formatter: '{value}',
                textStyle: {
                    color: '#bbbbbb'
                }
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            splitLine: {　　　　
                show: true,
                lineStyle:{
                    color:'#f5f6f7',
                    type:'dashed'
                }
            },
        },
        series: [
            {
                name: name,
                data: data,
                // data: [820, 932, 901, 934, 1290, 1330, 1320],
                type: 'line'
            }
        ]
    }
    //为eCharts对象加载数据
    theSeven.setOption(option);
    
}